import { FacilityAssetsData } from "../../components/FacilityAssets/FacilityAssetsWithStoreWithData"
import LostAssetsReport from "."

const LostAssetsReportWithData = FacilityAssetsData(LostAssetsReport)

export default LostAssetsReportWithData
